import type { RequireKeys } from "@p0security/util/types/util";

export type SupportedClientIntegration = "agentic" | "k8s" | "ssh";

export type ClientIdentifier = {
  orgSlug: string;
  targetId: string;
  integration: SupportedClientIntegration;
};

/** A resolved tenant's target — for callers that already have `tenantId` in
 * scope, so they don't need to re-derive it from `orgSlug`. */
export type TenantTargetIdentifier = {
  tenantId: string;
  targetId: string;
};

export const isSupportedIntegration = (
  integration?: string
): integration is SupportedClientIntegration => {
  return (
    integration === "ssh" || integration === "k8s" || integration === "agentic"
  );
};

export const toClientIdentifier = (clientId: string): ClientIdentifier => {
  const items = clientId.split(":");
  const [orgSlug, targetId, integration] = items;
  if (items.length === 2) return { orgSlug, targetId, integration: "k8s" }; // Default to k8s if no integration is specified
  if (items.length === 3 && isSupportedIntegration(integration)) {
    return {
      orgSlug,
      targetId,
      integration,
    };
  }
  throw new Error("Invalid client ID format");
};

export const toClientKey = (
  args: RequireKeys<Partial<ClientIdentifier>, "orgSlug" | "targetId">
) => {
  const { orgSlug, targetId, integration } = args;
  if (integration) return `${orgSlug}:${targetId}:${integration}`;
  return `${orgSlug}:${targetId}`;
};

export const BRAEKHUS_PROXY_PORT = 8081;
export const BRAEKHUS_PROXY_ADDRESS_LOCAL = `http://localhost:${BRAEKHUS_PROXY_PORT}/client`;
// App2's own in-cluster braekhus service address; integration-agnostic (used
// by k8s, self-hosted/ssh, and agentic gateway clients alike).
export const BRAEKHUS_PROXY_ADDRESS_INTERNAL = `http://braekhus.p0-namespace.svc.cluster.local:${BRAEKHUS_PROXY_PORT}/client`;
